import ga from '../utils/ga'

export const reportHomePageClick = (eventLabel: string) => () => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'HomePage',
    eventAction: 'click',
    eventLabel
  })
}

interface IClickOptions {
  eventLabel: string
  eventValue?: number
  dimension19?: string
}

export const reportBlockClick = (
  blockName: string,
  blockClickOptions: IClickOptions
) => {
  ga('send', {
    ...blockClickOptions,
    hitType: 'event',
    eventCategory: `Block interaction;${blockName}`,
    eventAction: 'click;button'
  })
}
